import { Ref } from "vue";
// eslint-disable-next-line import/no-unresolved, import/extensions
import useAuthentication from "@/composition/useAuthentication";
import { NewsItem } from "@/store/modules/newsItems/types.d";
import store from "@/store";
import useMatomoEvent from "@/composition/useMatomoEvent";
import getCurrentView from "@/composition/getCurrentView";

export default (newsItem: Ref<NewsItem>) => {
  return () => {
    store.dispatch("newsItems/bulkExportPDF", {
      selectedNewsItems: [newsItem.value],
      authJWT: useAuthentication().validateAndRetrieveToken()
    });

    useMatomoEvent({
      category: `${getCurrentView()} View`,
      name: `${getCurrentView()} View "PDF erstellen"`,
      action: `Click "PDF erstellen" in ${getCurrentView()} View`
    });
  };
};
